import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { ReactComponent as EnRomanhLogo } from './en-romanh.svg';
import { ReactComponent as ArRomanhLogo } from './ar-romanh.svg';
var RomanhIcon = function (_a) {
    var lang = _a.lang;
    if (lang === 'ar') {
        return (_jsx(ArRomanhLogo, {}));
    }
    return (_jsx(EnRomanhLogo, {}));
};
export default memo(RomanhIcon);
